class QuoterFilter {
    static filterResults(filterObject, quotes) {
        if (!filterObject) {return quotes;}
        let results = [...quotes];
        if (filterObject.noMedicalExamOnly) {results = results.filter(x => x.requiresMedicalExam.toLowerCase() === 'no');}
        if (filterObject.medicalExamOnly) {results = results.filter(x => x.requiresMedicalExam.toLowerCase() !== 'no');}
        if (filterObject.digitalOnly) {results = results.filter(x => (x.isDigitalProduct === true && x.requiresPhoneInterview === false));}
        if (filterObject.phoneOnly) {results = results.filter(x => (x.isDigitalProduct === false && x.requiresPhoneInterview === true));}
        if (filterObject.convertibleOnly) {results = results.filter(x => x.hasConvertibility === true);}
        if (filterObject.notConvertibleOnly) {results = results.filter(x => x.hasConvertibility !== true);}
        if (filterObject.levelTerm) {results = results.filter(x => x.isDecreasingTerm !== true);}
        if (filterObject.decreasingTerm) {results = results.filter(x => x.isDecreasingTerm === true);}
        return results;
    };
};
 
export default QuoterFilter;



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/Helpers/QuoterFilter.js